import React from 'react';
import PropTypes from 'prop-types';
import { Input, InputAddon } from '../assets/constants/styles';

class PasswordField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      PasswordType: 'password',
    };
    this.changeType = this.changeType.bind(this);
  }
  changeType() {
    const PasswordType = this.state.PasswordType === 'input' ? 'password' : 'input';
    this.setState({ PasswordType });
  }
  render() {
    const eyeIcon =
      this.state.PasswordType === 'input'
        ? 'glyphicon glyphicon-eye-open form-control-feedback'
        : 'glyphicon glyphicon-eye-close form-control-feedback';
    const eyeTitle = this.state.PasswordType === 'input' ? 'Hide' : 'Show';
    return (
      <div className="form-group has-feedback">
        <div className="input-group">
          <Input
            autoComplete="off"
            className="form-control"
            minLength="8"
            name={this.props.name}
            onChange={this.props.onChange}
            placeholder={this.props.placeholder}
            required="required"
            type={this.state.PasswordType}
            value={this.props.value}
          />
          <InputAddon className="input-group-addon" onClick={this.changeType} title={eyeTitle}>
            <span aria-hidden="true" className={eyeIcon} style={{ width: 25 }} />
          </InputAddon>
        </div>
      </div>
    );
  }
}
PasswordField.propTypes = {
  name: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.string,
};

export default PasswordField;
